var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeam = function SvgTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5h18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.333A2.667 2.667 0 1 0 12 6a2.667 2.667 0 0 0 0 5.333ZM8 19.333v-2.666A2.667 2.667 0 0 1 10.667 14h2.666A2.667 2.667 0 0 1 16 16.667v2.666M17 11.333A2.667 2.667 0 1 0 17 6M18.334 14A2.667 2.667 0 0 1 21 16.667v2.666M7 11.333A2.667 2.667 0 1 1 7 6M5.667 14A2.667 2.667 0 0 0 3 16.667v2.666",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTeam;